import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Grid, GridNoRecords, GridColumn as Column } from '@progress/kendo-react-grid';
import BobLoadingMask from '../../../components/BobLoadingMask';
import FsmIntegrationContextMenu from './FsmIntegrationContextMenu';
import RenameFsmAgentModal from '../Modals/RenameFsmAgentModal';
import ResetAuthKeyModal from '../Modals/ResetAuthKeyModal';
import DeleteFsmAgentModal from '../Modals/DeleteFsmAgentModal';

import { orderBy } from '@progress/kendo-data-query';

import * as ErpAgentActions from '../../../actions/erpAgentActions';

import * as classes from './FsmIntegrationView.module.css';

const FsmIntegrationView = ({
    activeNavCompany,
    bobLoading,
    erpAgents,
    fetchErpAgents,
    ...props
}) => {

    const [sort, setSort] = useState([]);
    const [integration, setIntegration] = useState({});
    const [resetAuthKeyModalOpen, setResetAuthKeyModalOpen] = useState(false);
    const [renameAgentModalOpen, setRenameAgentModalOpen] = useState(false);
    const [deleteAgentModalOpen, setDeleteAgentModalOpen] = useState(false);

    useEffect(() => {
        const init = async () => {
            await fetchErpAgents();
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    const actionsCell = props => {
        return (
            <td>
                <FsmIntegrationContextMenu
                    integration={props.dataItem}
                    setIntegration={setIntegration}
                    setDeleteAgentModalOpen={setDeleteAgentModalOpen}
                    setRenameAgentModalOpen={setRenameAgentModalOpen}
                    setResetAuthKeyModalOpen={setResetAuthKeyModalOpen}
                />
            </td>
        );
    };

    return (
        <div className={classes.TableContainer}>
            <div className={classes.Table}>
                <Grid
                    sortable
                    sort={sort}
                    onSortChange={(e) => {
                        setSort(e.sort);
                    }}
                    className={classes.KendoGrid}
                    data={orderBy(erpAgents, sort)}
                    total={erpAgents.length}
                    reorderable
                >
                    {
                        bobLoading.includes('FetchErpAgents') ?
                            <GridNoRecords>
                                Loading ERP Agents
                            </GridNoRecords>
                            :
                            null
                    }
                    <Column field="name" title="Name" width="auto" />
                    <Column field="agentType" title="FSM Drivers" width="150px" />
                    <Column field="agentSerial" title="Serial Number" width="350px" />
                    <Column field="softwareVersion" title="Software Version" width="auto" />
                    <Column
                        field=""
                        title=""
                        width="auto"
                        cell={actionsCell}
                    />
                </Grid>
            </div>
            {
                bobLoading.includes('FetchErpAgents') ?
                    <BobLoadingMask />
                    :
                    null
            }
            {
                deleteAgentModalOpen ?
                    <DeleteFsmAgentModal
                        integration={integration}
                        setDeleteAgentModalOpen={setDeleteAgentModalOpen}
                    />
                    :
                    null
            }
            {
                renameAgentModalOpen ?
                    <RenameFsmAgentModal
                        integration={integration}
                        setRenameAgentModalOpen={setRenameAgentModalOpen} 
                    />
                    :
                    null
            }
            {
                resetAuthKeyModalOpen ?
                    <ResetAuthKeyModal
                        integration={integration}
                        setResetAuthKeyModalOpen={setResetAuthKeyModalOpen}
                    />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
    bobLoading:       state.bob.bobLoading,
    erpAgents:        state.erpAgent.erpAgents
});

const mapDispatchToProps = {
    ...ErpAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(FsmIntegrationView);
